import { fmt, useT } from "../i18n/index.tsx";
import { IconAlert } from "./Icons.tsx";
import { CopyButton } from "./ui.tsx";

/** One secret value in a mono box with a copy button. */
export function SecretField({ label, value }: { label: string; value: string }) {
  const t = useT();
  return (
    <div className="secret">
      <div className="secret-label">
        <span>{label}</span>
        <CopyButton value={value} label={fmt(t.auth.copyLabel, { label: label.toLowerCase() })} showText />
      </div>
      <code className="secret-value">{value}</code>
    </div>
  );
}

/**
 * "Copy the {what} now…": `what` is a translated noun from the dictionary (t.auth.secretWord, t.auth.signingSecretWord).
 * `title` / `body` replace the default copy (API key secrets can be viewed again, so they don't say "never again").
 */
export function OnceWarning({ what, title, body }: { what?: string; title?: string; body?: string | null }) {
  const t = useT();
  const text = body === undefined ? t.auth.onceBody : body;
  return (
    <div className="once-warning" role="alert">
      <IconAlert size={20} />
      <div>
        <strong>{title ?? fmt(t.auth.onceTitle, { what: what ?? t.auth.secretWord })}</strong>
        {text && <span>{text}</span>}
      </div>
    </div>
  );
}
